import React from 'react';
import { SummaryRow } from '../../../Summary/SummaryRow';
import { VQ } from '../../../../store/student/types';
import { IVisaPrepForm, IFamilyMember } from '../../../../types';
import { boolToYesNo } from '../../../../utilities/formatting';
import { parseDate, formatDate } from 'shared-components';
import { Box } from '@chakra-ui/react';
import { SummaryGroup } from '../../../Summary/SummaryGroup';

function VisaPrepArrivalInfo(props: IVisaPrepForm) {
  const renderFamilyMembers = () => {
    const allFamilyMembers: React.ReactNode[] = [];
    if (props.familyMembers && props.familyMembers.length) {
      props.familyMembers.forEach((familyMember: IFamilyMember, i: number) => {
        allFamilyMembers.push(
          <SummaryGroup title={`Family member ${i + 1}`} key={i}>
            <SummaryRow
              className={'visa-summary'}
              key={`${VQ.NATIONALITY}-${i}`}
              value={familyMember.nationality}
              label="Nationality"
            />
            <SummaryRow
              className={'visa-summary'}
              key={`${VQ.FAMILY_NAME}`}
              value={familyMember.familyName}
              label="Family Name"
            />
            <SummaryRow
              className={'visa-summary'}
              key={`${VQ.GIVEN_NAME}`}
              value={familyMember.givenName}
              label="Given Name"
            />
            <SummaryRow
              className={'visa-summary'}
              key={VQ.DOB}
              label="Date of Birth"
              value={familyMember.dob ? formatDate(parseDate(familyMember.dob), 'DD/MM/YYYY') : ''}
            />
          </SummaryGroup>,
        );
      });
    }
    return allFamilyMembers;
  };
  return (
    <>
      <SummaryRow
        className={'visa-summary'}
        key={VQ.HAS_ARRIVAL_DATE}
        label={'Do you know your planned arrival date in the UK?'}
        value={boolToYesNo(props.hasArrivalDate)}
      />
      {props.hasArrivalDate === true && (
        <>
          <SummaryRow
            className={'visa-summary'}
            key={VQ.ARRIVAL_DATE}
            label={'Date of planned arrival in the UK'}
            value={props.arrivalDate}
          />
          <SummaryRow
            className={'visa-summary'}
            title="How long do you intend to stay in the UK?"
            key={VQ.LENGTH_IN_UK_INTENTION_DD}
            label={'Days'}
            value={`${props.lengthOfStayDays || 0}`}
          />
          <SummaryRow
            className={'visa-summary'}
            key={VQ.LENGTH_IN_UK_INTENTION_MM}
            label={'Months'}
            value={`${props.lengthOfStayMonths || 0}`}
          />
          <SummaryRow
            className={'visa-summary'}
            key={VQ.LENGTH_IN_UK_INTENTION_YY}
            label={'Years'}
            value={`${props.lengthOfStayYears || 0}`}
          />
        </>
      )}
      <SummaryRow
        className={'visa-summary'}
        key={VQ.UK_PRESENCE}
        label={'Do you have an established presence in the UK?'}
        value={boolToYesNo(props.ukPresence)}
      />
      <SummaryRow
        className={'visa-summary'}
        key={VQ.UK_FAMILY}
        label={'Do you have family in the UK?'}
        value={boolToYesNo(props.ukFamily)}
      />
      {props.ukFamily ? (
        <>
          <SummaryRow
            className={'visa-summary'}
            key={VQ.STAYING_WITH_FAMILY}
            label={'Will you be staying with any family members?'}
            value={boolToYesNo(props.stayingWithFamily)}
          />
          {props.stayingWithFamily ? (
            <>
              <SummaryRow
                className={'visa-summary'}
                label={'How many family members will you be staying with?'}
                value={props.familyMembers?.length}
              />
              <Box as="ol" pl={8} key={'Family members'}>
                {renderFamilyMembers()}
              </Box>

              <SummaryRow
                className={'visa-summary'}
                key={VQ.FAMILY_CONTACT_ADDRESS}
                label="Contact Address for Family you are staying with"
                value={props.familyContactAddress}
              />
              <SummaryRow
                className={'visa-summary'}
                key={VQ.FAMILY_CONTACT_CITY}
                label="City"
                value={props.familyContactCity}
              />
              <SummaryRow
                className={'visa-summary'}
                key={VQ.FAMILY_CONTACT_POSTCODE}
                label="Postcode"
                value={props.familyContactPostcode}
              />
              <SummaryRow
                className={'visa-summary'}
                key={VQ.FAMILY_CONTACT_COUNTRY}
                label="Country"
                value={props.familyContactCountry}
              />
              <SummaryRow
                className={'visa-summary'}
                key={VQ.FAMILY_CONTACT_NUMBER}
                label={'Contact number'}
                value={props.familyPhoneNumber}
              />
              <SummaryRow
                className={'visa-summary'}
                key={VQ.FAMILY_CONTACT_EMAIL}
                label={'Contact email address'}
                value={props.familyEmail}
              />
            </>
          ) : null}
        </>
      ) : null}
      <SummaryRow
        className={'visa-summary'}
        key={VQ.HAS_OTHER_CONTACT_ADDRESS}
        label={'Do you have another address in the UK?'}
        value={boolToYesNo(props.hasOtherContactAddress)}
      />
      {props.hasOtherContactAddress ? (
        <>
          <SummaryRow
            className={'visa-summary'}
            key={VQ.OTHER_CONTACT_ADDRESS}
            label="UK Contact Address"
            value={props.otherContactAddress}
          />
          <SummaryRow
            className={'visa-summary'}
            key={VQ.OTHER_CONTACT_CITY}
            label="City"
            value={props.otherContactCity}
          />
          <SummaryRow
            className={'visa-summary'}
            key={VQ.OTHER_CONTACT_POSTCODE}
            label="Postcode"
            value={props.otherContactPostcode}
          />
          <SummaryRow
            className={'visa-summary'}
            key={VQ.OTHER_CONTACT_COUNTRY}
            label="Country"
            value={props.otherContactCountry}
          />
          <SummaryRow
            className={'visa-summary'}
            key={VQ.OTHER_CONTACT_NUMBER}
            label={'Contact number'}
            value={props.otherPhoneNumber}
          />
        </>
      ) : null}
    </>
  );
}

export default VisaPrepArrivalInfo;
